import React, { useState, useEffect } from 'react';
import './Snackbar.css';

const Snackbar = ({ message, type = 'success', duration = 3000, onClose }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      if (onClose) {
        setTimeout(onClose, 300); // Allow fade out animation
      }
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  if (!isVisible && !message) return null;

  return (
    <div className={`snackbar snackbar--${type} ${isVisible ? 'snackbar--visible' : 'snackbar--hidden'}`}>
      <div className="snackbar__content">
        <span className="snackbar__message">{message}</span>
        <button
          className="snackbar__close"
          onClick={() => {
            setIsVisible(false);
            if (onClose) {
              setTimeout(onClose, 300);
            }
          }}
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default Snackbar;
